import { Option } from "./state/types.ts";
import React, { useEffect, useRef } from 'react';

export function clsx(...args: Array<string | undefined | false>) : string{
    return args.filter(s => (s !== undefined) && (s !== false)).join(' ');
}

export function  slugify(label: string) : string{
  return label
  .toLocaleLowerCase()
  .replaceAll('ä', 'ae')
  .replaceAll('ö', 'oe')
  .replaceAll('ü', 'ue')
  .replaceAll('Ä', 'Ae')
  .replaceAll('Ö', 'Oe')
  .replaceAll('Ü', 'Ue')
  .replaceAll('ß', 'ss')
  .replaceAll(' ', '-')
  .replaceAll('_', '-')
  .replaceAll(',', '')
  .replaceAll('.', '')
}


export function inverse_key_value(options: Array<Option>){
  return options.reduce((acc: Record<string,string>, o: Option)=>{
    acc[o.value] = o.label;
    return acc;
  },{});
}

export function round_to_10(x : number){
  return Math.floor(x);
  // const y = Math.round(x / 10) * 10;
  // if(Number.isNaN(y)){
  //   return 0;
  // }else{
  //   return y;
  // }
}

export function round_to_01(x : number){
  const y = Math.round(x * 10) / 10;
  if(Number.isNaN(y)){
    return 0;
  }else{
    return y;
  }
}

export function round_to_1000(x : number){
  const y = Math.round(x / 1000) * 1000;
  if(Number.isNaN(y)){
    return 0;
  }else{
    return y;
  }
}

export function format_1000(x : number) : string{
  return x.toLocaleString('de');
}

const useDidMountEffect = (first, other, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
          other();
        }else {
          didMount.current = true;
          first();
        }
    }, deps);
}

export default useDidMountEffect;

export function inputOnKeyUp(event: KeyboardEvent , closure: () => void){
  if(event.code != "Enter" && event.code != " "){return;}
  closure();
}